import * as React from "react";
import { Section } from "components/common";
import { Alert } from "components/bootstrap";
const StreamIlluminateProcessingSection = ({ stream }) => {
  if (!stream.title.startsWith("Illuminate")) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Section, { title: "Illuminate processing" }, /* @__PURE__ */ React.createElement(Alert, { bsStyle: "default" }, "The ", /* @__PURE__ */ React.createElement("b", null, "Illuminate Processing"), " step is an immutable Pipeline that occurs before user Pipelines in the default processing order.", /* @__PURE__ */ React.createElement("br", null), "It collects messages that meet supported formats from the All Messages stream, parses that data into the GIM schema fields and routes them to this Stream."));
};
export default StreamIlluminateProcessingSection;
